import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './components/header/header.component';
import { SharedModule } from '@app/shared/shared.module';
import { FooterComponent } from './components/footer/footer.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HeaderInterceptor } from './interceptors/http.interceptor';
import { AppConfigService } from './config/config.service';
import { TranslateService } from '@ngx-translate/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CustomTranslationHttpLoader } from './services/custom-translation-http-loader.service';
import { LanguageSelectorComponent } from './components/header/language-selector/language-selector.component';

@NgModule({
  imports: [CommonModule, SharedModule],
  declarations: [HeaderComponent, FooterComponent, LanguageSelectorComponent],
  exports: [HeaderComponent, FooterComponent],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HeaderInterceptor,
      multi: true,
      deps: [AppConfigService, TranslateService, MatSnackBar],
    },
    CustomTranslationHttpLoader,
  ],
})
export class CoreModule {}
